import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { UserFragmentDoc } from '../../../../../../../graphql/fragments/generated/User';
import { EntityMediaFragmentDoc } from '../../../../../../../features/messages/graphql/fragments/generated/MediaType';
import { PostReactionFragmentDoc } from '../../../../../../../features/reactions/graphql/fragments/generated/PostReaction';
export type PraiseDetailsFragment = { id: string, visibleToEveryone: boolean, postId: string, createdAt: string, receiverUsers: Array<{ id: string, name?: string | null, uniqueId: string, emailId?: string | null, profilePicture?: string | null, orgRole?: { id: string, name: string } | null }>, post?: { id: string, message: string, attachments?: Array<{ id: string, media: { name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null } }> | null, reactions?: Array<{ hasReacted?: boolean | null, reaction: string, count: number, userIds: Array<string>, users?: Array<{ id: string, name?: string | null, uniqueId: string, emailId?: string | null, profilePicture?: string | null, orgRole?: { id: string, name: string } | null }> | null }> | null, mentions?: Array<{ entityId: string, entityType: Types.MentionEntityTypeEnum }> | null } | null, praiseChannel?: { id: string } | null, createdBy?: { id: string, name?: string | null, profilePicture?: string | null } | null, skillRatings?: Array<{ skillId: string, skill?: { id: string, name: string } | null }> | null, mindsetRatings?: Array<{ mindsetId: string, MindSet?: { id: string, name: string } | null }> | null };


export type PraiseDetailsFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type PraisePostFragment = { id: string, message: string, attachments?: Array<{ id: string, media: { name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null } }> | null, reactions?: Array<{ hasReacted?: boolean | null, reaction: string, count: number, userIds: Array<string>, users?: Array<{ id: string, name?: string | null, uniqueId: string, emailId?: string | null, profilePicture?: string | null, orgRole?: { id: string, name: string } | null }> | null }> | null, mentions?: Array<{ entityId: string, entityType: Types.MentionEntityTypeEnum }> | null };


export type PraisePostFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type PraiseSkillRatingsFragment = { skillId: string, skill?: { id: string, name: string } | null };


export type PraiseSkillRatingsFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type PraiseMindsetRatingsFragment = { mindsetId: string, MindSet?: { id: string, name: string } | null };


export type PraiseMindsetRatingsFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const PraisePostFragmentDoc = /*#__PURE__*/ gql`
    fragment PraisePost on PostType {
  id
  message
  attachments {
    id
    media {
      ...EntityMedia
    }
  }
  reactions {
    ...PostReaction
  }
  mentions {
    entityId
    entityType
  }
}
    `;
export const PraiseSkillRatingsFragmentDoc = /*#__PURE__*/ gql`
    fragment PraiseSkillRatings on PeerFeedbackSkillRatingType {
  skillId
  skill {
    id
    name
  }
}
    `;
export const PraiseMindsetRatingsFragmentDoc = /*#__PURE__*/ gql`
    fragment PraiseMindsetRatings on PeerFeedbackMindsetRatingType {
  mindsetId
  MindSet {
    id
    name
  }
}
    `;
export const PraiseDetailsFragmentDoc = /*#__PURE__*/ gql`
    fragment PraiseDetails on PraiseType {
  id
  visibleToEveryone
  receiverUsers {
    ...User
  }
  postId
  post {
    ...PraisePost
  }
  praiseChannel {
    id
  }
  createdBy {
    id
    name
    profilePicture
  }
  createdAt
  skillRatings {
    ...PraiseSkillRatings
  }
  mindsetRatings {
    ...PraiseMindsetRatings
  }
}
    `;